import {
  AccountHistoryObjectTypeEnum,
  AccountHistoryOperationEnum,
  AccountStatusEnum,
} from '@monetize/types/app';

export const STATUS_OPTIONS = [
  { name: 'Active', value: 'ACTIVE' },
  { name: 'Inactive', value: 'INACTIVE' },
  { name: 'Canceled', value: 'CANCELED' },
  { name: 'Suspended', value: 'SUSPENDED' },
  { name: 'Archived', value: 'ARCHIVED' },
];

export const AccountStatusDisplayText: {
  [key in AccountStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  CANCELED: 'Canceled',
  SUSPENDED: 'Suspended',
  INACTIVE: 'Inactive',
  ARCHIVED: 'Archived',
};

export const AccountHistoryObjectTypeDisplayText: {
  [key in AccountHistoryObjectTypeEnum]: string;
} = {
  ACCOUNT: 'Account',
  BILL_GROUP: 'Bill Group',
  CONTACT: 'Contact',
  SUBSCRIPTION: 'Subscription',
  TEAM: 'Team',
};

export const AccountHistoryOperationDisplayText: {
  [key in AccountHistoryOperationEnum]: string;
} = {
  CREATE: 'Created',
  UPDATE: 'Updated',
  DELETE: 'Deleted',
};

export const billGroupDetailsTabs = new Set([
  'bill-groups',
  'payment-methods',
  'contacts',
  'overview',
]);
